import request from '@/utils/request'
// 公众号-管理员列表
export function getList(params) {
  return request({
    url: '/novel_management/wechat_users',
    method: 'get',
    params
  })
}

// 公众号-管理员添加
export function addManagement(data) {
  return request({
    url: '/novel_management/wechat_users',
    method: 'post',
    data
  })
}

// 公众号-管理员修改
export function modifyData(id, params) {
  return request({
    url: `/novel_management/wechat_users/${id}`,
    method: 'put',
    params
  })
}
// 获取公众号-管理员历史数据
export function getHistoryData(id) {
  return request({
    url: `/novel_management/wechat_users/${id}`,
    method: 'get'
  })
}
// 下载按钮
export function getFormData(params = null) {
  return request({
    url: `/report_form/export/book_roi`,
    method: 'post',
    params
  })
}
// 渠道列表
export function getchannelList(params) {
  return request({
    url: '/novel_management/channel',
    method: 'get',
    params
  })
}
// 小程序渠道列表
export function getwechatList(params) {
  return request({
    url: '/novel_management/miniprogram_channel',
    method: 'get',
    params
  })
}
// 小说小程序渠道列表
export function novel_getwechatList(params) {
  return request({
    url: '/novel_management/novel_miniprogram_channel',
    method: 'get',
    params
  })
}
// 渠道平台
export function getchannelplatform(params) {
  return request({
    url: '/common/channel_platform_list',
    method: 'get',
    params
  })
}
// 小程序渠道平台
export function getwechatplatform(params) {
  return request({
    url: '/common/miniprogram_channel_platform_list',
    method: 'get',
    params
  })
}
// 小程序渠道平台
export function noval_getwechatplatform(params) {
  return request({
    url: '/common/novel_miniprogram_channel_platform_list',
    method: 'get',
    params
  })
}
// 新增渠道号
export function addchannelNumber(data) {
  return request({
    url: '/novel_management/channel',
    method: 'post',
    data
  })
}
// 添加订单记录
export function addOrder(data) {
  return request({
    url: '/novel_management/channel/add_order_record',
    method: 'post',
    data
  })
}
// 下载按钮（新go接口）
export function newgetFormData(params = null) {
  return request({
    url: `/report_form/export/book_roi_v2`,
    method: 'post',
    params
  })
}
